import {
  IGetIvideonTokenParams,
  IIvideonAuthSignature,
} from "~/services/ivideon/model";
import { getConfiguredAxiosInstance } from "~/services/ivideon/lib/ConfigureAxiosInstance";
import { AxiosInstance } from "axios";
import { setIvideonCredentials } from "~/services/ivideon/lib/tokenWorkers";

export class IvideonHTTP {
  static self;

  clientId;
  redirectURI;
  generalAuthLink;
  ivideonAxiosInstance: AxiosInstance;
  stateToggle;

  private constructor(
    axiosInstance: AxiosInstance,
    toggleIvideonIsAuth: (bool: boolean) => void,
    dealerId: string
  ) {
    this.clientId = "autovaz_a2s";
    // необходим заменить для отладки так как идёт проверка домена у ivideon, подставить свой id.
    // this.redirectURI = `https://dealer-passport-test.xsfera.ru:3011/ivideon/dealers/${dealerId}`;

    this.redirectURI = `${window.location.origin}/ivideon/dealers/${dealerId}`;
    this.generalAuthLink = `https://api.ivideon.com/auth/oauth/authorize?response_type=code&client_id=${this.clientId}&redirect_uri=${this.redirectURI}`;
    this.ivideonAxiosInstance = axiosInstance;

    this.stateToggle = toggleIvideonIsAuth;
  }

  public static resetInstance() {
    this.self = null;
  }

  public static getInstance = (
    axiosInstance?: AxiosInstance,
    toggleIvideonIsAuth?: (bool: boolean) => void,
    dealerId?: string
  ) => {
    if (!this.self && axiosInstance && toggleIvideonIsAuth) {
      this.self = new IvideonHTTP(axiosInstance, toggleIvideonIsAuth, dealerId);
      return this.self;
    } else return this.self;
  };

  // старт авторизации (переход на страницу авторизации)
  startAuth() {
    window.open(this.generalAuthLink).focus();
  }

  // получение доступов из ответа (параметры приходят в поисковую строку)
  getAccess = async ({ code, client_id, id }: IGetIvideonTokenParams) => {
    const response = await fetch("https://api.ivideon.com/auth/oauth/token", {
      method: "POST",
      body: new URLSearchParams({
        grant_type: "authorization_code",
        code: code,
        client_id: client_id,
        redirect_uri: this.redirectURI,
      }),
    });

    const data: IIvideonAuthSignature = await response.json();

    if (!!data.access_token && !!data.refresh_token) {
      const { api_host, access_token, refresh_token, expires_in, api4_host } =
        data;
      setIvideonCredentials({
        DealerId: id,
        access_token,
        open_api_host: api_host,
        expires: expires_in,
        refresh_token,
        api_host: api4_host,
      });
    }
  };

  // Разобраться потом, как это можно было бы оптимизировать

  // this.stateToggle && this.stateToggle(true);
  // Если все в порядке, то сетим необходимые данные локально в куки

  // функция для сета api_host, access_token, refresh_token в куки

  // тут возвращаем состояние "авторизован" в компонент

  // обновляем axios экземпляр с новыми данными
  // this.ivideonAxiosInstance = getConfiguredAxiosInstance({
  //   baseURL: `https://${api_host}`,
  //   access_token,
  //   refresh_token,
  //   expires_in,
  //   api4_host,
  //   api_host,
  //   toggleIvideonIsAuth: this.stateToggle,
  //   id,
  // });
  // }

  // return data;
  // };

  getCamerasGroupList = () =>
    this.ivideonAxiosInstance.post("/folders?op=FIND");
  getCamerasGroupInstance = (id: string) =>
    this.ivideonAxiosInstance.post(`/folders/${id}?op=GET`);

  getCameraList = () => this.ivideonAxiosInstance.post("/cameras?op=FIND");
  getCameraById = (id: string) =>
    this.ivideonAxiosInstance.post(`/cameras/${id}?op=GET`);

  getCameraPreview = (cameraId) =>
    this.ivideonAxiosInstance.get(`/cameras/${cameraId}/live_preview`, {
      responseType: "arraybuffer",
    });

  getCameraStream = (cameraId) =>
    this.ivideonAxiosInstance.get(`/cameras/${cameraId}/live_stream`, {
      params: { expect: "body", format: "hls", video_codecs: "h264,h265" },
    });
}
